import React from 'react'
import { css } from "@emotion/react";
import RingLoader from "react-spinners/BeatLoader";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: rgba(255,255,255,0.7);
  border-width: 10px;
`;

const Loading = (prop) => {
  const check = prop.loading == null ? false : prop.loading

  return (
    check &&
    <div className='axios-loading' style={{display:prop.loading===true?'block':'none'}}>
        <div className='axios-loading-indicator'>
            <RingLoader color={"white"} loading={prop.loading} css={override}  size={45} />
        </div>
    </div>
  )

}

export default Loading